import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function MobileWarning() {
  const { t } = useTranslation("global");

  return (
    <div className="fixed sm:hidden top-0 left-0 inset-1 z-[10000] bg-white bg-opacity-75 flex flex-col items-center justify-center text-white">
      <div className="px-4 py-8 bg-gray-800 rounded-lg shadow-xl max-w-sm md:max-w-lg mx-auto text-center">
        <img
          src={`${process.env.PUBLIC_URL}/header/ERA_logo.png`}
          alt="Era NL logo"
          className="h-16 mx-auto"
        />
        <h1 className="text-3xl font-bold mt-6">{t("mobileWarning.letOp")}</h1>
        <p className="text-lg mt-4">{t("mobileWarning.text1")} </p>
        <img
          src={`${process.env.PUBLIC_URL}/noPhone.svg`}
          className="h-40 mt-4 mx-auto"
          alt="Geen mobiele ondersteuning"
        />
        <p className="text-lg my-4">{t("mobileWarning.text2")}</p>

        <Link
          to={process.env.PUBLIC_URL}
          className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-secondaryOrange hover:brightness-110 hover:shadow-none transition-all"
        >
          {t("mobileWarning.text3")}
        </Link>
      </div>
    </div>
  );
}
